import Script from 'next/script'
import { FC } from 'react'

export const InsiderScript: FC = () => {
  return <Script id="insider" async src="https://omensbr.api.useinsider.com/ins.js?id=10009965" />
}
